// extracted by mini-css-extract-plugin
export default {"namespace":"v","elNamespace":"el"};